<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Laporan Bil Dikeluarkan">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <!-- <z-lookup
                            label="Akaun"
                            :url="service_bil_pelbagai + 'lookup/akaun_inbois'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.akaun_id"
                        /> -->
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                        <z-lookup
                            label="Cawangan"
                            :url="service_bil_pelbagai + 'lookup/jabatan_user'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="33%" style="float:left;">
                        <thead>
                            <tr>
                                <td colspan="2" style="text-align:center;">Baharu</td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">Bil</td>
                                <td style="text-align:center;">Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.baharu_items">
                                <td>{{ dt.no }}</td>
                                <td style="text-align:right;">{{ dt.amaun }}</td>
                            </tr>
                            <tr v-for="index in table.extra_baharu_rows">
                                <td>&nbsp;</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-dashboard" width="33%" style="float:left;">
                        <thead>
                            <tr>
                                <td colspan="2" style="text-align:center;">Bayar</td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">Bil</td>
                                <td style="text-align:center;">Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.bayar_items">
                                <td>{{ dt.no }}</td>
                                <td style="text-align:right;">{{ dt.amaun }}</td>
                            </tr>
                            <tr v-for="index in table.extra_bayar_rows">
                                <td>&nbsp;</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-dashboard" width="33%" style="float:left;">
                        <thead>
                            <tr>
                                <td colspan="2" style="text-align:center;">Batal</td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">Bil</td>
                                <td style="text-align:center;">Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.batal_items">
                                <td>{{ dt.no }}</td>
                                <td style="text-align:right;">{{ dt.amaun }}</td>
                            </tr>
                            <tr v-for="index in table.extra_batal_rows">
                                <td>&nbsp;</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table-dashboard" width="99%" style="float:left;">
                        <tr>
                            <td width="33%"><b>JUMLAH <span style="float:right">{{table.total_baharu}}</span></b></td>
                            <td width="33%"><b> <span style="float:right">{{table.total_bayar}}</span></b></td>
                            <td width="33%"><b> <span style="float:right">{{table.total_batal}}</span></b></td>
                        </tr>
                    </table>
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_bil_pelbagai + "laporan/bil_keluar",
            reload: true,
            resit_id: null,
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Bil Pelbagai", route: "/bil_pelbagai/laporan/bil_keluar" },
                { label: "Laporan", route: "/bil_pelbagai/laporan/bil_keluar" },
                {
                    label: "Laporan Bil Keluar",
                    route: "/bil_pelbagai/laporan/bil_keluar",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" },
        };
    },
    methods: {
        search() {
            this.$inertia.visit(
                window.route("bil_pelbagai.laporan.bil_keluar") +
                    "?tarikh_dari=" +
                    this.cari.tarikh_dari +
                    "&tarikh_hingga=" +
                    this.cari.tarikh_hingga +
                    "&jabatan_id=" +
                    this.cari.jabatan_id,
                { preserveScroll: true }
            );
        },
        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" };
            this.search();
        },

        cetak() {
           window.open(this.service_bil_pelbagai+'laporan/bil_keluar/cetak?user_id='+this.auth.user.id+
            "&tarikh_dari=" +
            this.cari.tarikh_dari +
            "&tarikh_hingga=" +
            this.cari.tarikh_hingga +
            "&jabatan_id=" +
            this.cari.jabatan_id,'_blank');
            },
        },
        watch: {},
    mounted() {
        // override default setting
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
